import React from 'react';
import { Grid, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EirInformation from '../../eir-information/EirInformation';
import PrepayStandaloneOfferCardContainer from './PrepayStandaloneOfferCardContainer';
import { getCookie } from '../../../hooks/useCookie';

/**
 * @name PrepayStandaloneOfferContainer - jsx component for compatible addons
 * @param {object} cmsData - Strapi data
 * @param {Array} handsetCode - Handset Code returned from getHandset
 * @returns {JSX.Element} - Returns Preapy handset container
 */
const PrepayStandaloneOfferContainer = ({
  cmsDataPrepay,
  loading,
  handsetCode,
  loadingHandset,
  addons,
  setShowNext,
  setAddons,
}) => {
  const theme = useTheme();

  return (
    <Stack>
      <Grid item xs={12}>
        {getCookie('PREPAY_STANDALONE_HANDSET') === 'true' && (
          <EirInformation
            title={cmsDataPrepay?.attributes?.eirInformationHandsetDetails?.title}
            description={cmsDataPrepay?.attributes?.eirInformationHandsetDetails?.description}
            textAlign={cmsDataPrepay?.attributes?.eirInformationHandsetDetails?.textAlign}
            useH1={cmsDataPrepay?.attributes?.eirInformationHandsetDetails?.useH1}
          />
        )}
      </Grid>
      <Grid item xs={12} sx={{ background: theme.palette.secondary.contrastText }}>
        {getCookie('PREPAY_STANDALONE_HANDSET') === 'true' && (
          <PrepayStandaloneOfferCardContainer
            loading={loading}
            handsetCode={handsetCode}
            loadingHandset={loadingHandset}
            addons={addons}
            setShowNext={setShowNext}
            setAddons={setAddons}
          />
        )}
      </Grid>
    </Stack>
  );
};

PrepayStandaloneOfferContainer.displayName = 'PrepayStandaloneOfferContainer';
export default PrepayStandaloneOfferContainer;
